// Draft store for the Create School Report page (see helpers/formDraft). One
// per user per child, so reports for two children don't overwrite each other.
import { anyFilled, createDraftStore } from 'helpers/formDraft';

export const schoolReportDraftStore = createDraftStore({
  prefix: 'school-report-draft',
  hasContent: values =>
    anyFilled([
      values?.term,
      values?.overallGrade,
      values?.subjects?.[0]?.name,
      values?.subjects?.[0]?.grade,
      values?.daysPresent,
      values?.daysAbsent,
      values?.strengths,
      values?.areasForImprovement,
      values?.generalComments,
      values?.extracurricular,
      values?.healthNotes,
      values?.recommendations
    ])
});

export const schoolReportDraftScope = (userId, beneficiaryId) =>
  `${userId || 'anon'}:${beneficiaryId || ''}`;
